// 3rd-party modules
import { Skeleton, Typography } from "antd";
import { useEffect, useState } from "react";

// project modules
import { apiCall } from "../../helpers/apiHelper";
import { convertToPersian, formatMoney } from "../../helpers/objectHelper";
import useTranslation from "../../hooks/TranslationContext";

//apis
import * as ReportApi from '../../apis/reportApi';

export default function SpecificDateCreatedServicesCountReport() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [datasource, setDatasource] = useState<any>(0);
  const abortController = new AbortController();

  useEffect(() => {
    getDataAsync();
  }, []);

  const getData = async (abortSignal?: AbortSignal) => {
    const response = await apiCall(ReportApi.getSpecificDateCreatedServicesCount(convertToPersian(), abortSignal));

    return response.success ? Number(response.data?.value || 0) : 0;
  };

  const getDataAsync = async () => {
    setLoading(true);
    setDatasource(await getData(abortController.signal));
    setLoading(false);
  }

  return (
    <>
      <Typography.Title level={3}>
        {
          loading ?
          <Skeleton.Input active />
          :
          formatMoney(datasource)
        }
      </Typography.Title>
      <Typography.Text>{t("total-created-items-count-today")}</Typography.Text>
    </>
  )
}
